import { render, staticRenderFns } from "./TutorialClips.vue?vue&type=template&id=6066a3a0&scoped=true&"
import script from "./TutorialClips.vue?vue&type=script&lang=js&"
export * from "./TutorialClips.vue?vue&type=script&lang=js&"
import style0 from "./TutorialClips.vue?vue&type=style&index=0&id=6066a3a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066a3a0",
  null
  
)

export default component.exports